import { render, staticRenderFns } from "./UserStatusIcon.vue?vue&type=template&id=c5fc6ccc&"
import script from "./UserStatusIcon.vue?vue&type=script&lang=js&"
export * from "./UserStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./UserStatusIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports